module.exports = __webpack_public_path__ + "static/img/2_1.435946c3.jpg";